<ng-container [ngTemplateOutlet]="mdd.template"></ng-container>